let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("UrhAm")).then(() => parcelRequire('6faJr'));